import { FilterConfigPassive } from '@/types/filter/filterConfig';

// Passive until a sales cube exists: options and `applyFilter` land with the schema.
const salesMyTerritoryFilter: FilterConfigPassive<string> = {
  label: 'global.filters.formControls.salesMyTerritoryLabel',
  options: [],
  defaultValue: false,
  type: 'checkbox',
  searchable: false,
  clearable: false,
};

export default salesMyTerritoryFilter;
